import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Pricing Guide", href: "/cost-guide" },
  { label: "Service Areas", href: "/service-areas" },
  { label: "Free Quote", href: "/free-quote" },
];

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white ${
        scrolled ? "shadow-md" : "border-b border-gray-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-14 md:h-16">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 cursor-pointer" onClick={(e) => { e.preventDefault(); navigate("/"); }}>
          <div className="w-8 h-8 flex items-center justify-center bg-[#1B4332] rounded-lg">
            <i className="ri-tree-line text-white text-base"></i>
          </div>
          <span className="font-extrabold text-[#1B4332] text-base hidden sm:block whitespace-nowrap">TreeTrimmingPrices</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); navigate(item.href); setMenuOpen(false); }}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap text-gray-600 hover:text-[#1B4332] ${location.pathname === item.href ? "font-bold text-[#1B4332]" : ""}`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="/free-quote"
            onClick={(e) => { e.preventDefault(); navigate("/free-quote"); }}
            className="bg-[#1B4332] text-white text-sm font-semibold px-5 py-2 rounded-lg hover:bg-[#2d6a4f] transition-colors cursor-pointer whitespace-nowrap"
          >
            Get Free Quote
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-2xl cursor-pointer text-[#1B4332]"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); navigate(item.href); setMenuOpen(false); }}
              className="text-[#1B4332] font-medium text-base text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="/free-quote"
            onClick={(e) => { e.preventDefault(); navigate("/free-quote"); setMenuOpen(false); }}
            className="bg-[#1B4332] text-white font-semibold px-5 py-3 rounded-full cursor-pointer whitespace-nowrap text-center"
          >
            Get Free Quote
          </a>
        </div>
      )}
    </nav>
  );
}
